const React = require("react");
const T = React.PropTypes;

const ActionCreators = require("../actionCreators/FileSelectionActionCreators.js");

const File = require("../types/File.js");

const FileInfoBox = require("./FileInfoBox.jsx");
const SelectedFile = require("./SelectedFile.jsx");
const UploadFileDetails = require("./UploadFileDetails.jsx");

const SelectedFileProgress = React.createClass({
    propTypes: {
        File: File.Type.isRequired,
        style: T.object
    },
    getDefaultProps() {
        return {
            style: {}
        };
    },
    render() {
        const fileNode = (<SelectedFile key={this.props.File.UID} File={this.props.File} />);

        const infoNode = (<UploadFileDetails File={this.props.File } />);

        return (<FileInfoBox style={this.props.style}
                             FileNode={fileNode}
                             InfoNode={infoNode} />);
    }
});

module.exports = SelectedFileProgress;


// WEBPACK FOOTER //
// ./src/components/SelectedFileProgress.jsx